<template>
  <div class="registration">
    <div class="container">
      <div class="row">
        <div class="col">
         
          <div class="registration--card">
             <div class="text-center" style="background-color: black;padding: 17px;border-radius: 40px 40px 0 0;">
            <img width="90" src="@/assets/icons/acg-logo.svg" alt="Logo"> 
          </div>
            <h2 style="padding-top: 20px;">Regisztráció</h2>
            <div class="registration--card--form">

              <validation-observer v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(formSubmit)">

                  <div class="form-group">
                    <label>Név</label>

                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input
                          type="text"
                          class="form-control"
                          name="Név"
                          placeholder="A teljes neved"
                          v-model="loginForm.name"
                      />
                      <div class="form__error">{{ errors[0] }}</div>

                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail cím</label>
                    <ValidationProvider rules="email|required" v-slot="{ errors }">
                      <input
                          type="text"
                          class="form-control"
                          name="E-mail cím"
                          placeholder="e-mail cím"
                          v-model="loginForm.email"
                      />
                      <div class="form__error">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label>Jelszó</label>
                    <ValidationProvider v-slot="{ errors }"  vid="confirmation" :rules="{required: true , regex: /^(?=.*(?:\d|[^\dA-Za-z]))(?=.*[A-Z]).*$/, min:8}">
                      
                        <input
                            class="form-control"
                            placeholder="Jelszó"
                            name="Jelszó"
                            type="password"
                            v-model="loginForm.psw"
                        />
                        <div class="form__error">{{ errors[0] }}</div>
                      
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <label>Jelszó mégegyszer</label>
                    <ValidationProvider v-slot="{ errors }" rules="required|confirmed:confirmation">
                      
                        <input
                            class="form-control"
                            placeholder="Jelszó mégegyszer"
                            name="Jelszó megerősítése"
                            type="password"
                            v-model="loginForm.psw_confirm"
                        />
                        <div class="form__error">{{ errors[0] }}</div>
                      
                    </ValidationProvider>
                  </div>

                  <div class="button-group">
                    <div class="error--s" v-if="error.length > 0">{{ error }}</div>
                    <button type="submit" class="btn btn-primary mt-4">Regisztrálok</button>
                  </div>
                </form>
              </validation-observer>

              <div v-if="registered" class="form__error text-center margin-top--medium">Már regisztráltál ezzel az e-mail
                címmel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {ValidationObserver} from "vee-validate";
import apiHandlerMI from "@/mixins/apiHandlerMI";
import {
  ValidationProvider, extend,
} from "vee-validate/dist/vee-validate.full.esm";
import {required, regex, confirmed, min} from 'vee-validate/dist/rules';
// setInteractionMode('eager');


extend('required', {
  ...required,
  message: "{_field_} megadása kötelező."
});
extend('min', {
  ...min,
  message: "Legalabb 8 karakter szükséges."
});
extend('regex', {
  ...regex,
  message: "A jelszónak tartalmaznia kell legalább egy nagy betűt, és egy speciális karaktert vagy számot"
});
extend("confirmed", {
  ...confirmed,
  message: "A jelszó nem egyezik",
});

export default {

  data() {
    return {
      name: "Registration",
      loginForm: {
        name: undefined,
        email: undefined,
        psw: undefined,
        psw_confirm: undefined,
      },
      registered: false,
      error: []
    };
  },
  mixins: [apiHandlerMI],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    formSubmit() {
      const _this = this

      _this.post('register',
          {
            name: _this.loginForm.name,
            email: _this.loginForm.email,
            password: _this.loginForm.psw,
            passconf: _this.loginForm.psw_confirm
          },
          {}, function () {
            //success
            // console.log(response.data)
            // if (response.data.token != null || response.data.token != '' || response.data.token != undefined) {              
            //   localStorage.setItem('ebus_token', response.data.token)
            //   _this.$store.state.token = response.data.token //ezt ki kellene hagyni...elvileg local storage-ból tudni kellene kivennie..
            //   _this.$store.state.user = response.data.user
              _this.$router.push({name: 'LogIn'})
            // }

          }, function ({response}) {
            if (response.data.status === false) {
              let errorsArray = Object.entries(response.data.error);

              for (const [errorName, errorValue] of errorsArray) {
                if (errorName === "email" &&
                    errorValue ===
                    "The email is already used!"
                ) {
                  _this.registered = true;
                }

              }
            }
          }
      )
    }
  }
}
</script>

<style scoped>

</style>